<template>
  <div>
    <div class="main">
      <div class="main--content">
        <div class="main--title">

          <!-- <a :href="`./images/pavilion-studios_supplement-op.pdf`">Download PDF</a> -->
        </div>
        <div class="grid-- mt-2">
             <span class="m-t2">● List</span> <br>  <router-link to="/">Slideshow</router-link>
        </div>
      </div>
      <div class="main--list p mt-1 fs-sm" v-if="images">
              <div class="image" v-for="(image, key) in images" :key="`image-item${key}`">
                <img class="mt-1" :src="`./images/${image.url}`"/>
                <span v-html="`${image.caption}`" class="caption"></span>
              </div>
      </div>
      <div class="footer p mt-2 mb-1">
        <span>Follow on <a href="https://www.instagram.com/fieldexperiments">Instagram</a>. </span>
        <span><a href="https://confirmsubscription.com/h/t/D251C439679F6EF4" target="_blank">Sign up</a> to Newsletter. </span>
        <span><a href="mailto:mail@field-experiments.com">Contact us</a>. </span>
        <span>Copyright Field Experiments {{ new Date().getFullYear() }}. </span>
      </div>
    </div>
  </div>
</template>

<script>
import images from '@/data/gallery'
import { Glide, GlideSlide } from 'vue-glide-js'

export default {
  name: 'book',
  components: {
    [Glide.name]: Glide,
    [GlideSlide.name]: GlideSlide
  },
  props: {
    backgroundColor: String
  },
  data() {
    return {
      images: images,
      active: 0,
      totalItems: null
    }
  },
  mounted() {
    this.totalItems = this.images.length
  },
  methods: {
    nextItem() {
      if (this.active === this.totalItems - 1) this.active = 0
      else this.active += 1
    },
    previousItem() {
      if (this.active === 0) this.active = this.totalItems - 1
      else this.active -= 1
    }
  }
}
</script>

<style lang="scss">
.main {
  &--list {
    display:flex;
    flex-wrap:wrap;
    .image {
      flex:0 0 80%;
      padding-right: 1rem;
      display: flex;
      align-items: flex-end;
      flex-wrap: wrap;
      .caption {
        margin-left: 1rem;
      }
      img {
        width:33.33vw;
      }
    }
    @include media_query(mobile-port) {
      .image {
        flex:0 0 100%;
        padding-right: 0rem;
        .caption {
          margin-top: 0.2rem;
          margin-left: 0rem;
        }
        img {
          width: 100%;
        }
      }
    }
  }
  .footer a {
    &:hover{
      color: gray;
      cursor: pointer;
    }
  }
}


</style>
